import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-variable-code-block-create',
  templateUrl: './variable-code-block-create.component.html',
  styleUrls: ['./variable-code-block-create.component.scss']
})
export class VariableCodeBlockCreateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
